import { BrowserStorageCache, KatalWeblabClient, Treatment, Weblab } from '@amzn/katal-weblab';
import { KatalWebSellerCentralClient, WeblabType } from '@amzn/katal-weblab-sellercentral';
import { SERVICE_NAME } from '../constants/constants';

export class WeblabClient {

    // Cache for 30 minutes: 30 * 60
    private static readonly cache: BrowserStorageCache = new BrowserStorageCache(SERVICE_NAME, 1800);
    private static katalWeblabClient = new KatalWeblabClient({
        weblabProxy: new KatalWebSellerCentralClient(),
        treatmentCache: WeblabClient.cache
    });

    public static fetchTreatment = async(weblab: Weblab) : Promise<Treatment> => {
        return await WeblabClient.katalWeblabClient.getTreatment(weblab);
    }
}